export default `
<div>
  <div class="container-fluid">
    <h2>Flagged Content</h2>
    <feed-item item="item" show-flag-reason="true" ng-repeat="item in store.feedItems" on-hide-flagged-item="removeContent(item)"></feed-item>
    <ut-load-more (load-more)="store.loadMore()" [is-loading]="store.isLoading" [is-last-page]="store.isLastPage"></ut-load-more>
  </div>
</div>
`;
